namespace Gordic.Pod.Dlg
{
    const { gcontent } = Decorators

    @gcontent
    export class PotvrzeniODoruceniDlg extends GContentBase<Gordic.Wfl.AC.WflBaseAC> 
    {
        data: Interface.GPotvrzeniElPodaniDto[];
        potvrzeni: Interface.GPotvrzeniElPodaniDto;
        poradi: number = 0;
        isInit: boolean = true;
        validators: any;
        onContentReady()
        {
            this.poradi = 0;
            this.SetData();
            Gordic.Wfl.AC.WflBaseAC.InitControl(this);
            switch (this.data.length)
            {
                case 0: this.dialogs.alert("jres:23900076"); //RC 23900076 : Potvrzení o doručení el. podání nebylo nalezeno.
                    this.close();
                    break;
                case 1:
                    break
                default:
                    // odeslano vickrat
                    this.topActions.push(this.CreateActionPredchozi());
                    this.topActions.push(this.CreateActionNasledujici());
                    break;
            }

            Gordic.Wfl.AC.WflBaseAC.CompleteMenu(this);
        }

        SetData()
        {
            this.potvrzeni = this.data[this.poradi];
            const that = this;
            const form = new Gordic.Forms
                .Form({ name: "frmPotvrzeni", layoutDescriptor: "L1M1S1" })
                .addSection()
                .addRow("jres:23900058") //RC 23900058 : Typ zprávy
                .addField("gstringbox", { name: "typ_zpr_txt", disabled: true } )
                .addRow("jres:31950073") //RC 31950073 : Odesílatel
                .addField("gstringbox", { name: "mail_from", disabled: true })
                .addRow("jres:23900017") //RC 23900017 : Adresát
                .addField("gstringbox", { name: "mail_to",  disabled: true })
                .addRow("jres:23900055") //RC 23900055 : Předmět
                .addField("gstringbox", { name: "predmet", disabled: true })
                .addRow("jres:23900056") //RC 23900056 : Přílohy
                .addField("gstringbox", { name: "prilohy", disabled: true })
                .addRow("jres:23900059") //RC 23900059 : Poznámka
                .addField("gstringbox", { name: "poznamka", disabled: true })
                .addRow("jres:23900032") //RC 23900032 : Odesláno
                .addField("gdatebox", { name: "dat_zmena", disabled: true })
                .addRow("jres:23900062") //RC 23900062 : Odeslal
                .addField("gstringbox", { name: "nazev_ref", disabled: true })
                .addRow("jres:23900063") //RC 23900063 : Podepsáno
                .addField("gstringbox", { name: "cert_info", disabled: true, rows: 6})
                .addField("gstringbox", { name: "poradi", disabled: true })

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.potvrzeni);
        }

        CreateActionPredchozi(): GAction {
            var that = this;
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Predchazejici,
                icon: Gordic.Gin.Icons.ActionEnum.predchazejici,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                caption: "jres:23900197",  //RC 23900197 : Předchozí
                run: function (ev, ctx)
                {
                    if (that.poradi > 0)
                    {
                        that.poradi -= 1;
                        that.UpdateInfo();
                        that.actions[Gordic.Gin.Globals.Enums.ActionsName.Nasledujici].enabled(true)
                    }
                    else
                    {
                        that.actions[Gordic.Gin.Globals.Enums.ActionsName.Predchazejici].enabled(false)
                    }
                }
            });
            return action;
        }

        CreateActionNasledujici(): GAction {
            var that = this;
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Nasledujici,
                icon: Gordic.Gin.Icons.ActionEnum.nasledujici,
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                caption: "jres:23900198", //RC 23900198 : Následující
                run: function (ev, ctx) {
                    if (that.poradi < (that.data.length -1)) {
                        that.poradi += 1;
                        that.UpdateInfo();
                        that.actions[Gordic.Gin.Globals.Enums.ActionsName.Predchazejici].enabled(true)
                    }
                    else
                    {
                        that.actions[Gordic.Gin.Globals.Enums.ActionsName.Nasledujici].enabled(false)
                    }
                }
            });
            return action;
        }

        UpdateInfo()
        {
            var that = this;
            this.potvrzeni = this.data[this.poradi];
            this.call<string>("GetInfoOCertifikatu", { model: this.potvrzeni })
                .done(function (cert_info)
                {
                    that.potvrzeni.cert_info = cert_info;
                    that.findFields().gfield("model", "apply", that.potvrzeni);
                })
        }
        
        OKClick()
        {
            this.close();       
        }
    }
}